window.pages['search.index'] = {
    init: function () {
        window.components.searchcontainer.init();
    },
};
